import React, { Fragment } from 'react';
import { styled } from 'dripsy';

import { BaseText, RichText, Separator } from '@components';
import { IS_WEB } from '@utils';
import { Course } from '@models/Courses/CourseModel';

const Title = styled(BaseText)({
  color: '$heading800',
  variant: IS_WEB ? 'text.xbig' : 'text.xlarge',
  fontWeight: 'semi',
});

const Description = styled(RichText)({
  color: '$text400',
  variant: IS_WEB ? 'text.small' : 'text.medium',
});

interface ICourseDescriptionProps {
  course: Course;
}

export const CourseDescription = ({
  course,
}: ICourseDescriptionProps) => {
  return (
    <Fragment>
      <Title>{course.title}</Title>
      <Separator size={['$4', '$5']} />
      <Description>{course.description}</Description>
    </Fragment>
  );
};
